import { IExportDeductionItemRepository, IExportDeductionItemRequest } from "@/core/repositories/export/export.deductionItem";
import { PrivateHttp } from "@/infrastructure/adapters/http";
import { ApiEndpoints } from "@/infrastructure/services/config";

export class ExportDeductionItemRepository implements IExportDeductionItemRepository {
  async exportDeductionItem(data: IExportDeductionItemRequest): Promise<{ signedUrl: string; success: boolean }> {
    const response = await new PrivateHttp().post<{ signedUrl: string; success: boolean }>(ApiEndpoints.EXPORT_CHARGE_BREAKDOWN, data);
    return response;
  }
}
